import Slider from './Slider';

export default Slider;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/slider/index.js
// module id = 433
// module chunks = 0